module.exports = __webpack_public_path__ + "static/media/Dice.2f908e6f.png";